import { useMutation } from '@tanstack/react-query';

import type {
  CreateSaleOrderParams,
  MutationResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCreateSaleOrderMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: CreateSaleOrderParams }) =>
      HttpClient.request<MutationResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });
